// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"268":"52ac355c","429":"90b3f00a","453":"222d32ad","498":"e2285cd4","551":"bc6f7fa0"}[chunkId] + ".chunk.js";
};